export default {
  AVAILABLE_VALUES: `Available values: `,
  CURRENT_FILTER: `Current filter`,
  ABSENCE_REASON: `Absence reason`,
  FILTERS: `Filters`,
  APPROVAL_REQUIRED: `Approval required`,
  APPROVED: `Approved`,
  ARCHIVED_PROJECTS: `Archived Templates`,
  ARCHIVED_TEMPLATES: `Archived Templates`,
  ASKED_FOR_CHANGES: `Requested changes`,
  NOT_ONBOARDED: `Never onboarded`,
  NEVER_CONNECTED: `Never connected`,
  ATTRIBUTE_TYPES: `Attribute Types`,
  ATTRIBUTES: `Attribute`,
  BLOCKED: `blocked`,
  CANCEL: `Cancel`,
  CANCELLED: `Cancelled shift`,
  CANNOTBESELFASSIGNED: `Can't be self-assigned`,
  CHECK_ONLY_TIME_OFF: `Limit to certain time off types`,
  CHECK_ONLY: `Check only {{ name }}`,
  CLIENTS: `Client`,
  CUSTOMTAG: `Custom Tag`,
  CLIENT_SENIORITIES: `Client based seniority`,
  POSITION_SENIORITIES: `Position based seniority`,
  CONTACT_LIST_STATUS: `List status`,
  CONTACT_USER_FLAG: `Contact User Flag`,
  CONTRACT_TYPE: `Contract`,
  CREATED_BY_LABEL: `Created by {{ fullName }} ({{ employeeNumber }})`,
  CREATED_BY: `Created By`,
  CURRENTLY_CALLING: `Currently calling`,
  CUSTOM: `Custom dates`,
  DATES: `Dates`,
  DEPARTMENT: `Department`,
  DONT_CHECK_TIME_OFF: `Ignore certain time off types`,
  DONT_CHECK: `Ignore {{ name }}`,
  EARLY_OUT_REASON: `Early out reason`,
  EARLY_OUT_TYPE: `Early out`,
  EARNING_CODE: `Earning code`,
  ELIGIBLE_FOR: `Eligible for {{ position }}`,
  EMPLOYEE_TYPE: `Employee type`,
  FILTER_REQUESTS_ABSENCE: `Absences`,
  FILTER_REQUESTS_ALL: `All attendance requests`,
  FILTER_REQUESTS_DELAY: `Late requests`,
  FILTER_REQUESTS_EARLY_OUT: `Early departures`,
  FILTER_REQUESTS_VACATION: `Time off`,
  FINALIZED: `Finalized`,
  HAS_ISSUES: `Has issues`,
  HAS_COMMENTS: `Has comments`,
  HAS_TRANSFERS: `Has transfers`,
  HAS_NOT_ATTRIBUTE: `Does not have {{ name }}`,
  HAS_NOT_DEPARTMENT: `Not in {{ name }}`,
  HAS_NOT_POSITION: `Does not have {{ name }}`,
  HASSPECIFICREQUIREMENTS: `Has specific requirements`,
  HIDE_FINALIZED: `Hide Finalized`,
  HIRING_DATA_TYPES: `Hiring data types`,
  HIRING_DATA: `Hiring Data`,
  IS_ARCHIVED: `Is archived`,
  IS_AVAILBLE: `Is available`,
  IS_ELIGIBLE: `Is eligible`,
  IS_NOT_ON_TIME_OFF: `Has no time off on this day`,
  IS_NOT_WORKING: `Is not working`,
  ISEXTRASHIFT: `Variable end time`,
  ISIRREPLACEABLE: `Should not be replaced`,
  ISOVERTIME: `Overtime`,
  ISONCALL: `On call`,
  LATE_REASON: `Late reason`,
  LATE_TYPE: `Lateness`,
  LEAVE_TYPE: `Absence`,
  LOCATION: `Location`,
  LOCKED: `locked`,
  MISSING_ATTRIBUTES: `Missing Attribute`,
  MISSING_DEPARTMENT: `Missing Department`,
  MISSING_POSITIONS: `Missing position`,
  NEEDSREPLACEMENT: `Needs to be replaced`,
  COVEREDOTHERUNIT: `Covered by another unit`,
  NO_CURRENT_FILTER: `No filter currently applied`,
  NO_EMAIL_SET: `No email address`,
  NO_EMAIL: `No Email`,
  NO_FILTER_SAVED: `No preset saved`,
  NO_PHONE_NUMBER_SET: `No phone number`,
  NO_PHONE_NUMBER: `No Phone Number`,
  NO_SAVED_PRESETS: `No saved search presets`,
  NO_VACATION_DURING_WEEK: `Has no time off this week`,
  CHECK_PARTIAL_TIME_OFF_ONLY: `Check partial time off only`,
  IGNORE_PARTIAL_TIME_OFF: `Ignore partial time off`,
  LAST_SEVEN_DAYS: `Last 7 days`,
  LAST_THIRTY_DAYS: `Last 30 days`,
  LAST_365_DAYS: `Last year`,
  CURRENT_PAY_PERIOD: `Current pay period`,
  PREVIOUS_PAY_PERIOD: `Previous pay period`,
  LAST_WEEK: `Last week`,
  YESTERDAY: `Yesterday`,
  NOEMPLOYEEAVAILABLE: `No employee available`,
  NON_ASSIGNABLE: `Non assignable`,
  NOT_VALIDATED: `Not validated`,
  NO_RESULTS: `No results found`,
  PERMIT_TYPE: `Permit`,
  POSITION: `Position`,
  PERMISSION: 'Permission',
  POSITIONS: `Positions`,
  PERMISSIONS: 'Permissions',
  PREFERRED: `preferred`,
  PROJECT_BLOCKED: `Project (Blocked)`,
  PROJECT_CODE: `Project Code`,
  PROJECT_LOCKED: `Project (Locked)`,
  PROJECT_OWNER: `Project Owner`,
  PROJECT_PREFERRED: `Project (Preferred)`,
  PROJECT_STATUS: `Project status`,
  PROJECT_TAG: `Project Tag`,
  PROJECT: `Project`,
  PUNCH_FLAG: `Punch flag`,
  PUNCH_STATUS: `Punch status`,
  REGION: `Region`,
  REPLACED: `Replaced shift`,
  REPORTS_TO: `Reports to`,
  REPORTS_TO_NAME: `Reports to {{ fullName }}`,
  REPORTS_TO_ME: `Reports to me`,
  REQUEST_FLAGS: `Request Warnings`,
  REQUEST_OPTIONS_TYPES: `Request options`,
  REQUEST_OPTIONS: `Attendance reasons and time off type`,
  REQUEST_STATUS: `Request status`,
  REQUEST_TYPE: `Attendance request type`,
  REQUIREMENT: `Requirement`,
  REQUIRES_ACTION: `Requires attention`,
  RESOURCES: `Resource`,
  CONTEXTUAL_FILTERS: `Contextual filters`,
  RESTRICTION: `Restriction`,
  SAVE: 'Save',
  SAVED_PRESET: `Saved preset`,
  SAVED_PRESETS: `Saved search presets`,
  SCHEDULE_EVENT_FLAGS: `Shift flags`,
  SCHEDULE_MODIFICATIONS_REASONS: `Schedule modification reasons`,
  SCHEDULE_TEMPLATES: `Schedule template`,
  SCHEDULE_TYPES: `Shift Type`,
  SEARCH: `Search`,
  SELECT: `Select`,
  SELECT_ALL: `All`,
  SELECT_NONE: `None`,
  SELECT_DATES: `Filter by date`,
  SELFASSIGN: `Assignable by an employee`,
  SHIFTOPTIONS: `Shift option`,
  SHOW_ABSENCES_OVER_THRESHOLD: `Show absences over the threshold`,
  SHOW_INTEGRATION_ERRORS: `Show integration errors`,
  SHOW_ALL_POSITIONS: `Show all positions`,
  SHOW_ALL_SCHEDULED_PROJECTS: `Show all scheduled projects`,
  SHOW_CANCELLED_ONLY: `Cancelled shifts`,
  SHOW_FINALIZED: `Finalized shifts`,
  SHOW_UNPUNCHED_SHIFTS: `Unpunched shifts`,
  NO_PROJECT: `No project assigned`,
  UNCONFIRMED_BY_USER: `Unconfirmed by employee`,
  SKILL: `Skill`,
  SUMMARY: `Search presets allows you to save and easily reuse search queries.`,
  TAGS_TYPES: `Type of tags`,
  TAGS: `Tags`,
  TEAM: `Team`,
  TEMPLATE_NAME: `Template name`,
  TIME_OFF_TYPE: `Time off`,
  TITLE: `Search presets`,
  TODAY: `Today`,
  TYPE_TO_SEARCH: `Search here`,
  UNASSIGNED: `Unassigned shift`,
  UNPUBLISHED_SHIFTS: `Unpublished shifts`,
  USER_ELIGIBLE_FOR_POSITION: `Eligible for (position name)`,
  USER_STATUS: `User status`,
  USER: `User`,
  VACATION_TYPE: `Vacation type`,
  VIEW_LESS: `View less`,
  VIEW_MORE: `View more`,
  WAGE_PREMIUMS: `Wage Premiums`,
  ABSENCE_REASON_DESCRIPTION: `Allows you to filter based on one of the available leave reasons.`,
  ARCHIVED_PROJECTS_DESCRIPTION: `Allows you to display archived projects.`,
  ARCHIVED_TEMPLATES_DESCRIPTION: `Allows you to display archived templates.`,
  ATTRIBUTE_TYPES_DESCRIPTION: `Allows you to filter according to the specified attribute type.`,
  ATTRIBUTES_DESCRIPTION: `Allows you to filter according to the specified attribute.`,
  CLIENT_DESCRIPTION: `Allows you to filter by clients.`,
  CONTACT_LIST_STATUS_DESCRIPTION: `Allows you to filter by the list's status.`,
  CONTACT_USER_FLAG_DESCRIPTION: `Allows you to filter by the flags of a contact user.`,
  CREATED_BY_DESCRIPTION: `Allows you to search for results created by the specified user.`,
  DEPARTMENT_DESCRIPTION: `Allows you to filter based on one of the available departments.`,
  EARLY_OUT_REASON_DESCRIPTION: `Allows you to filter based on one of the available early out reasons.`,
  FINALIZED_DESCRIPTION: `Allows you to filter for finalized shifts.`,
  HIRING_DATA_DESCRIPTION: `Allows you to filter based on any available hiring data.`,
  HIRING_DATA_TYPES_DESCRIPTION: `Allows to filter by type of hiring data.`,
  IS_ARCHIVED_DESCRIPTION: `Search for archived users.`,
  LATE_REASON_DESCRIPTION: `Allows you to filter based on one of the available late reasons.`,
  LOCATION_DESCRIPTION: `Allows you to filter based on the location.`,
  LOCATIONS_DESCRIPTION: `Allows you to filter according to the specified punch location (will lookup either the arrival or departure location).`,
  MISSING_ATTRIBUTES_DESCRIPTION: `Allows you to search for users that do not have the specified attribute.`,
  MISSING_DEPARTMENT_DESCRIPTION: `Allows you to search for users that do not have the specified department.`,
  MISSING_POSITIONS_DESCRIPTION: `Allows you to search for users that do not have the specified position.`,
  NAME_DESCRIPTION: `The name should describe what this preset will return as search result.`,
  NO_EMAIL_DESCRIPTION: `Search for users without an email.`,
  NO_PHONE_NUMBER_DESCRIPTION: `Search for users without a phone number.`,
  NOT_VALIDATED_DESCRIPTION: "Search for users who haven't been validated yet.",
  POSITION_DESCRIPTION: `Allows you to filter based on one of the available positions.`,
  POSITIONS_DESCRIPTION: `Allows you to search for users that have the specified position.`,
  PERMISSION_DESCRIPTION: 'Allows you to filter based on one of the available permissions.',
  PERMISSIONS_DESCRIPTION: 'Allows you to search for users that have the specified permission.',
  PROJECT_BLOCKED_DESCRIPTION: `Allows you to display users who are blocked from a project.`,
  PROJECT_CODE_DESCRIPTION: `Allows you to filter for the code of a project.`,
  PROJECT_DESCRIPTION: `Allows you to filter based on one of the available projects.`,
  PROJECT_LOCKED_DESCRIPTION: `Allows you to display users who are locked to a project.`,
  PROJECT_OWNER_DESCRIPTION: `Allows you to filter according to the project owner(s).`,
  PROJECT_PREFERRED_DESCRIPTION: `Allows you to display users who are preferred on a project.`,
  PROJECT_STATUS_DESCRIPTION: `Allows you to search for projects matching the provided status.`,
  PROJECT_TAG_DESCRIPTION: `Allows you to search for tags associated to a project.`,
  PUNCH_FLAG_DESCRIPTION: `Allows you to filter according to the specified flag.`,
  PUNCH_STATUS_DESCRIPTION: `Allows you to filter according to the specified status.`,
  REGION_DESCRIPTION: `Allows you to filter by the regions associated to the shifts.`,
  REPORTS_TO_DESCRIPTION: `Allows you to filter according to the specified user to whom the team reports.`,
  REQUEST_FLAGS_DESCRIPTION: `Allows you to filter according to the specified warning.`,
  REQUEST_OPTIONS_DESCRIPTION: `Allows to filter by attendance reasons and time off type.`,
  REQUEST_OPTIONS_TYPES_DESCRIPTION: `Allows to filter by type of request options.`,
  REQUEST_STATUS_DESCRIPTION: `Allows you to filter according to the specified status.`,
  REQUEST_TYPE_DESCRIPTION: `Allows you to filter according to the request type.`,
  REQUIRES_ACTION_DESCRIPTION: `Will display the punch cards that require attention.`,
  RESOURCES_DESCRIPTION: `Allows you to filter by resource tags applied to the the shifts.`,
  SCHEDULE_EVENT_FLAGS_DESCRIPTION: `Allows you to filter based on one of the available shift flags.`,
  SCHEDULE_MODIFICATIONS_REASONS_DESCRIPTION: "Allows you to filter by the reasons of the shift's modification",
  SCHEDULE_TEMPLATES_DESCRIPTION: `Allows you to filter by what template the shifts came from.`,
  SCHEDULE_TYPES_DESCRIPTION: `Allows filtering by shift types.`,
  SHOW_ALL_POSITIONS_DESCRIPTION: `Usefull to display all the shifts with some of the time off types.`,
  SHOW_CANCELLED_ONLY_DESCRIPTION: `This filter allows you to only display shifts that have been cancelled.`,
  TAG_TYPES_DESCRIPTION: `Allows to filter by type of tags.`,
  TAGS_DESCRIPTION: `Filter by tags`,
  TEAM_DESCRIPTION: `The name of a team to search for.`,
  TEMPLATE_NAME_DESCRIPTION: `Allows you to search for schedule templates by name.`,
  USER_DESCRIPTION: `The name or employee number of a user to search for.`,
  USER_ELIGIBLE_FOR_POSITION_DESCRIPTION:
    "Allows you to display all the current shift which a user is available for a specific position based on it's attributes.",
  VACATION_TYPE_DESCRIPTION: `Allows you to filter based on one of the available vacation types.`,
  WAGE_PREMIUMS_DESCRIPTION: `Allows you to filter by wage premiums applied to the shifts.`,
  DELETE_PRESET_CONFIRMATION_MODAL: {
    TITLE: `Delete a saved search preset`,
    SUMMARY: `Are you sure you want to delete the search preset {{presetName}} ?`
  },
  HELP_MODAL: {
    TITLE: ``,
    SUMMARY: ``
  },
  punch: {
    ISINEARLY: `Is in early`,
    ISINLATE: `Is in late`,
    ISOUTEARLY: `Is out early`,
    ISOUTLATE: `Is out late`,
    FLAG_NOT_PUNCHED_IN: `Not punched in`,
    FLAG_NOT_PUNCHED_OUT: `Not punched out`,
    FLAG_NO_SHIFT: `No shift associated`,
    FLAG_DUPLICATE_SHIFT: `Duplicate punch card`,
    FLAG_NO_CLOCKED_TIME: `No clocked time`,
    FLAG_LOCATION_CONFLICTS: `Punch location conflicts`
  },
  contactLists: {
    ARCHIVED: `Archived`,
    CREATED: `Not started`,
    PAUSED: `Paused`,
    RUNNING: `Running`
  },
  contactUsers: {
    SHOULDCALL: `Should be called`,
    SHOULDNOTCALL: `Should not be called`,
    CALLEDMANUALLY: `Called manually`,
    NOTCALLEDMANUALLY: `Not called manually`,
    NOTCONTACTEDYET: `Not contacted yet`,
    CONTACTCOMPLETED: `Contact completed`,
    ISINDELAY: `Is in delay`,
    HASBEENBUMPED: `Has been bumped`,
    ACCEPTED: `Accepted shift`,
    REFUSED: `Refused all shifts`,
    OTHERCHECKNOTES: `Other, check notes`
  }
}
